import { commonDefaultSettings } from '../commonDefaultSettings';

/**
  @deprecated константа заменена на хук. Например: choiceSettings => useChoiceSettings
*/

export const choiceSettings = {
  ...commonDefaultSettings,
  label: 'Choice',
  hint: '',
  options: [
    {
      name: 'Option 1',
      id: 'yayuk8ve'
    },
    {
      name: 'Option 2',
      id: 'twjpfkt4'
    }
  ],
  otherOption: false,
  otherOptionLabel: 'Other',
  otherOptionPlaceholder: 'Type your answer',
  multiple: true,
  randomize: false,
  numColumns: 1,
  required: false,
  showLabel: true,
  width: 100,
  presetWidth: 100,
  fieldID: 'choice'
};
